import HeaderComponent from "./Components/shared/HeaderComponent";


function App() {
  return (
    <section className="section-app bg-gradient-to-tl from-green-800 via-red-500 to-sky-800">
      <HeaderComponent/>
    </section>
  );
}

export default App;
